<template>
  <div class="panel-body">
    <div v-html="description.content"></div>
  </div>
</template>

<script>
import WarehouseAcrossService from '@/services/warehouseacrossservice'
// import EventService from '@/services/eventservice'
// import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      description: {
        kind: null,
        title: null,
        content: null
      },
      loader: null
    }
  },
  created () {
    this.getDescriptions()
  },
  methods: {
    async getDescriptions () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.getDescriptions()
        .then((response) => {
          this.description = response.data
        })
        .catch((err) => {
          this.$events.fire('handleError', err)
        })
      this.loader && this.loader.hide()
    }
  },
  mounted () {
    // if (this.currentTab && this.currentTab === 'top') {
    //   let logParams = {
    //     name: '',
    //     properties: {}
    //   }
    //   EventService.postTrackLog(logParams)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/Top.vue